/** TODO: are those editable traces? -> not specifically for custom charts */
export const customTrace = {
  key: null,
  name: '',
  // color: '#333',
  thickness: 1.5,
  dash: null,
  opacity: 1,
  ids: null,
}

export type Dash = 'dash' | 'dot'
